
    import { Component, Vue, Prop, Watch } from "vue-property-decorator";
    import { PendingShift, Event } from '@/models';
    import ErrorNotification from "./ErrorNotification.vue";
    import ConfirmMsgPopUp from "@/views/shared/ConfirmMsgPopUp.vue";
    import { namespace } from "vuex-class";
    import moment from "moment";
    import { ModelListSelect } from 'vue-search-select'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { useAppInsights } from '../../store/modules/AppInsights'

    const schedule = namespace("schedule");
    const profile = namespace("profile");
    @Component({
        components: {
            ErrorNotification,
            ModelListSelect,
            Loading,
            ConfirmMsgPopUp
        },
    })
    export default class SelfSchedule extends Vue {
        @schedule.State
        public selfScheduleShiftMembers!: any;
        @schedule.State
        public assignmentDetail!: any;
        @schedule.State
        public pendingShiftDetails!: any;
        @schedule.State
        public selfScheduleShiftDetails: any;
        @profile.State
        public profileData!: any;
        @profile.State
        isAdmin!: boolean;
        @schedule.State
        public selfScheduleFacilities: any;
        @schedule.State
        public selfScheduleDepartments: any;
        @schedule.State
        public userSchedules!: any;
        @schedule.State
        public selfScheduleSkills: any;

       
        @profile.State
        appInsightEventData!: any;
        @profile.State
        isImpersonating!: boolean;
        
        shiftMembers: any = [];
        isLoaded: boolean = false;
        isProductive: boolean = false;
        canModify: boolean = false;
        isSelfScheduled: boolean = false;
        deptShifts: any = [];
        skillName!: string;
        buttonCaption: string = "Add to Schedule";
        buttonName: string = "btnAddToSchedule";
        tenantId!: string;
        staffId!: number;
        deptId!: number;
        skillId!: number;
        err: string = '';
        shiftStartTime!: Date;
        shiftEndTime!: Date;
        actualStartTime!: Date;
        actualEndTime!: Date;
        actualShiftStartTime: string = "6:30am";
        actualShiftEndTime: string = "6:30pm";
        deptShiftId: number = 0;
        deptShiftDesc: string = '';
        deptShiftCode!: string;
        productiveType: string = '';
        isModalVisible: boolean = false;
        errorMsg: string = '';
        errorType: string = 'error';
        showErrorMsg: boolean = false;
        classFlag: string = '';
        isSelfScheduleAllowed: boolean = false;
        allowSelfScheduleToCommitment: boolean = false;
        guranteedHrs: number = 0;
        weeksInSchedule: number = 4;
        displayWSC: boolean = true;
        reqCountWSC: number = 0;
        facilities: any = [];
        facilityDepts: any = [];
        selectedFacilityId: number = 0;
        selectedDeptId: number = 0;
        skills: any = [];
        selectedSkillId: number = 0;
        selectedDeptShiftId: string = '';
        selectedDeptAndShift: any = {
            tenantId: '',
            facilityId: 0,
            coid: '',
            facilityName: '',
            departmentId: 0,
            departmentName: '',
            departmentCode: '',
            departmentShiftId: 0,
            shiftCode: '',
            shiftDescription: '',
            startTime: '',
            endTime: '',
            shiftMembers: []
        };
        facilityCoid: number = 0;
        departmentCode: number = 0;
        facilityName: string = '';
        departmentName: string = '';
        isLoading: boolean = false;
        loaderColor: string = "#0085ca";
        isConfirmModalVisible: boolean = false;
        confirmMsgValue: string = '';
        datesList: any = [];
        pendingShiftList: PendingShift[] = [];
        isSelfScheduleNeedsInPrimaryDept: boolean = true;
        assignmntDetail: any = null;

        @Prop() currentEvent!: Event;
        @Prop() dayChanged!: any;
        @Prop() scheduleStatus!: any;
        @Prop() isSelfScheduledEvent!: any;
        @Prop() calSelectedDates!: any;
        @Prop() scheduleId!: any;
        @Prop() departmentsCanSelfSchedule!: any;

        async mounted() {
            this.buttonCaption = (this.currentEvent.type == "Need" || this.currentEvent.type == undefined ? "Add to Schedule" : "Withdraw");
            this.buttonName = (this.currentEvent.type == "Need" ? "btnAddToSchedule" : "btnWithdraw");
            this.skillName = this.profileData.skills.find(x => x.primary == true).description;
            this.tenantId = this.profileData.tenantId;
            this.staffId = this.profileData.staffId;
            this.deptId = this.profileData.deptId;
            this.skillId = this.profileData.skills.find(x => x.primary == true).id;
            this.isSelfScheduleAllowed = this.profileData.selfSchedule;
            this.allowSelfScheduleToCommitment = this.profileData.selfScheduleToCommitment;
            this.skills = this.profileData.skills;
            this.guranteedHrs = this.profileData.guarenteedHours;
            this.weeksInSchedule = this.profileData.weeksInSchedule;
            this.displayWSC =
                this.profileData.weekendShiftCommitment != 0 ? true : false;
            this.reqCountWSC = this.profileData.weekendShiftCommitment;
            if (this.currentEvent.type == "Pending") {
                this.canModify = true;
                this.getPendingShiftDetails();
            }
            else if (this.currentEvent.type == "Assignment" && this.currentEvent.status == "Scheduled" &&
                this.isSelfScheduleAllowed == true) //
            {
                this.getAssignmentDetails();
            }
            else if (this.currentEvent.type == "Assignment" && this.currentEvent.status == "Pending" &&
                this.scheduleStatus == "Plan Sheet" && this.isSelfScheduledEvent == true) //
            {
                this.getAssignmentDetails();
            }
            else //"Need"
            {
                this.canModify = true;
                if (this.currentEvent.type == undefined) {
                    await this.showCalenderSelectedDates();
                }
                this.getSelfScheduleNeedsDetails();
            }
        }

        async showCalenderSelectedDates() {
            var startSD = moment(this.calSelectedDates.startDate, 'M/D/YYYY');
            var endSD = moment(this.calSelectedDates.endDate, 'M/D/YYYY');
            var diffDays = endSD.diff(startSD, 'days');
            let calCurrentDate: Date = new Date(this.calSelectedDates.startDate);
            let selectedDatesCount: number = 0;
            let todayDate: Date = new Date();
            if (calCurrentDate < todayDate) {
                calCurrentDate = todayDate;
                let currentDiffDays = (moment(todayDate, 'M/D/YYYY')).diff(startSD, 'days');
                diffDays = diffDays - currentDiffDays;
            }
            selectedDatesCount = diffDays;
            for (var i = 0; i < diffDays; i++) {
                let singleDate = {
                    id: i,
                    dateValue: calCurrentDate,
                    isSelected: true
                }
                this.datesList[i] = JSON.parse(JSON.stringify(singleDate));
                calCurrentDate.setDate(calCurrentDate.getDate() + 1);
            }
        }

        toggleDateSelection(event) {
            let currentId = event.currentTarget.id;

            for (var i = 0; i < this.datesList.length; i++) {
                if (this.datesList[i].id == currentId) {
                    let currentStatus: boolean = (this.datesList[i].isSelected);
                    this.datesList[i].isSelected = !(this.datesList[i].isSelected);
                    if (currentStatus) {
                        event.currentTarget.classList.remove("neu-background--cerulean-25");
                        event.currentTarget.classList.add("neu-background--white");
                    }
                    else {
                        event.currentTarget.classList.remove("neu-background--white");
                        event.currentTarget.classList.add("neu-background--cerulean-25");
                        if (this.showErrorMsg) {
                            this.showErrorMsg = false;
                            this.errorMsg = "";
                        }
                    }
                }
            }
        }

        getDisplayDate(currentId) {
            for (var i = 0; i < this.datesList.length; i++) {
                if (this.datesList[i].id == currentId) {
                    return moment(this.datesList[i].dateValue).format("dddd, MMMM D");
                }
            }
            return "";
        }

        onFacilityChange(event) {
            this.selectedFacilityId = event.target.value;
            this.facilityDepts = this.selfScheduleDepartments.filter(x => x.facilityId == event.target.value);
            this.facilityName = this.facilities.find(f => f.facilityId == event.target.value).facilityName;
            this.facilityCoid = this.facilities.find(f => f.facilityId == event.target.value).coid;
            this.selectedDeptId = this.facilityDepts[0].departmentId;
            this.departmentName = this.facilityDepts[0].departmentCode;
            this.departmentCode = this.facilityDepts[0].departmentName;            

            let filteredskills = this.removeDuplicatesFromArrayByProperty(this.selfScheduleSkills.filter(x => x.departmentId == this.selectedDeptId),'skillLevelId');           
            this.skills = filteredskills;
            let primarySkillId = this.profileData.skills.find(x => x.primary == true).id
            let selectedSkill = this.skills.find(s => s.skillLevelId == primarySkillId);
            
            if (selectedSkill == 'undefined' || selectedSkill == null) {                            
                selectedSkill = this.skills[0]
            }

            this.selectedSkillId = Number(selectedSkill.skillLevelId);
            this.skillName = selectedSkill.skill;

            this.deptShifts = this.removeDuplicatesFromArrayByProperty(this.selfScheduleShiftDetails.filter(x => x.departmentId == this.selectedDeptId).filter(s => s.skillLevelId = this.selectedSkillId), 'shiftCode');

            this.deptShifts.forEach((shift: any) => {
                let startTime, endTime;
                startTime = this.formatTime(this.addMinutes(shift.startTime, shift.offset));
                endTime = this.formatTime(this.addMinutes(this.addMinutes(shift.endTime, shift.offset), shift.breakMinutes));

                if (shift.shiftDescription.trim().toUpperCase() == shift.shiftCode.trim().toUpperCase()) {
                    shift.shiftDescription = shift.shiftDescription + " " + startTime.toUpperCase() + " - " + endTime.toUpperCase();
                }
            });

            const selecteId = +this.deptShifts[0].departmentShiftId + '_' + this.deptShifts[0].departmentId;
            this.selectedDeptShiftId = selecteId;
            this.selectedDeptAndShift = this.deptShifts[0];
            this.setShiftDetails(this.deptShifts[0].departmentShiftId, this.deptShifts[0].departmentId);
        }

        onDepartmentChange(event) {
            this.selectedDeptId = parseInt(event.target.value);
            this.departmentName = this.selfScheduleShiftDetails.find(x => x.departmentId == event.target.value).departmentCode;
            this.departmentCode = this.selfScheduleShiftDetails.find(x => x.departmentId == event.target.value).departmentName;

            let filteredskills = this.removeDuplicatesFromArrayByProperty(this.selfScheduleSkills.filter(x => x.departmentId == this.selectedDeptId),'skillLevelId');
            this.skills = filteredskills;
            let primarySkillId = this.profileData.skills.find(x => x.primary == true).id
            let selectedSkill = this.skills.find(s => s.skillLevelId == primarySkillId);
            
            if (selectedSkill == 'undefined' || selectedSkill == null) {                            
                selectedSkill = this.skills[0]
            }

            this.selectedSkillId = Number(selectedSkill.skillLevelId);
            this.skillName = selectedSkill.skill;

            this.deptShifts = this.removeDuplicatesFromArrayByProperty(this.selfScheduleShiftDetails.filter(x => x.departmentId == this.selectedDeptId).filter(s => s.skillLevelId = this.selectedSkillId), 'shiftCode');

            this.deptShifts.forEach((shift: any) => {
                let startTime, endTime;
                startTime = this.formatTime(this.addMinutes(shift.startTime, shift.offset));
                endTime = this.formatTime(this.addMinutes(this.addMinutes(shift.endTime, shift.offset), shift.breakMinutes));

                if (shift.shiftDescription.trim().toUpperCase() == shift.shiftCode.trim().toUpperCase()) {
                    shift.shiftDescription = shift.shiftDescription + " " + startTime.toUpperCase() + " - " + endTime.toUpperCase();
                }
            });

            const selecteId = +this.deptShifts[0].departmentShiftId + '_' + this.deptShifts[0].departmentId;
            this.selectedDeptShiftId = selecteId;
            this.selectedDeptAndShift = this.deptShifts[0];

            this.setShiftDetails(this.deptShifts[0].departmentShiftId, this.deptShifts[0].departmentId);
        }

        onSkillChange(event) {
            this.selectedSkillId = Number(event.target.value);
            this.skillName = this.skills.find(x => x.skillLevelId == event.target.value).skill;
        }

        onShiftChanges(event) {
            this.selectedDeptShiftId = event;
            this.selectedDeptAndShift = this.deptShifts.find(x => x.departmentShiftId == event.departmentShiftId && x.departmentId == event.departmentId);
            this.setShiftDetails(event.departmentShiftId, event.departmentId);

            if (this.showErrorMsg) {
                this.showErrorMsg = false;
                this.errorMsg = "";
            }
        }

        setShiftDetails(deptShiftId, deptId) {
            const selectedDeptShift = this.deptShifts.find(x => x.departmentShiftId == deptShiftId
                && x.departmentId == deptId);
            this.shiftMembers = selectedDeptShift.shiftMembers;
            this.shiftStartTime = selectedDeptShift.startTime;
            this.deptShiftCode = selectedDeptShift.shiftCode;
            this.deptShiftDesc = selectedDeptShift.shiftDescription;
            this.productiveType = selectedDeptShift.productiveType;
            this.shiftEndTime = selectedDeptShift.endTime;
            this.actualStartTime = this.addMinutes(selectedDeptShift.startTime, selectedDeptShift.offset);
            this.actualEndTime = this.addMinutes(this.addMinutes(selectedDeptShift.endTime, selectedDeptShift.offset), selectedDeptShift.breakMinutes);
            this.actualShiftStartTime = this.formatTime(this.actualStartTime);
            this.actualShiftEndTime = this.formatTime(this.actualEndTime);
        }

        removeDuplicatesFromArrayByProperty = (arr, prop) => arr.reduce((accumulator, currentValue) => {
            if (!accumulator.find(obj => obj[prop] === currentValue[prop])) {
                accumulator.push(currentValue);
            }
            return accumulator;
        }, [])

        getPendingShiftDetails() {
            this.assignmntDetail = null;
            this.$store
                .dispatch("schedule/GetPendingShiftDetails", { id: this.currentEvent.id, username: this.profileData.username })
                .then(() => {
                    this.isLoaded = true;
                    if (this.pendingShiftDetails != undefined) {
                        this.facilityName = this.pendingShiftDetails.facilityName;
                        this.departmentName = this.pendingShiftDetails.departmentName;
                        this.skillName = this.pendingShiftDetails.skill;
                        this.skillId = this.skills.find(s => s.id == this.pendingShiftDetails.skillId);
                        this.deptShiftId = this.pendingShiftDetails.departmentShiftId;
                        this.deptShiftDesc = this.pendingShiftDetails.shiftDescription;
                        this.shiftStartTime = this.pendingShiftDetails.startTime;
                        this.shiftEndTime = this.pendingShiftDetails.endTime;
                        this.actualStartTime = this.pendingShiftDetails.actualStartTime;
                        this.actualEndTime = this.pendingShiftDetails.actullEndTime;
                        this.actualShiftStartTime = this.pendingShiftDetails.actualStartTime;
                        this.actualShiftEndTime = this.pendingShiftDetails.actualEndTime;
                    }
                })
                .catch((err: any) => {
                    if (err) {
                        console.log(err); // Handle errors any way you want
                    }
                });
        }

        getAssignmentDetails() {
             const payload = { id: this.currentEvent.id, username: this.profileData.username};

            this.$store
                .dispatch("schedule/GetScheduleAssignmentDetail", payload)
                .then(() => {
                    this.isLoaded = true;
                    if (this.assignmentDetail != undefined) {
                        this.assignmntDetail =  this.assignmentDetail;
                        this.facilityName = this.assignmentDetail.facilityName;
                        this.departmentName = this.assignmentDetail.departmentCode;
                        this.skillName = this.assignmentDetail.skill;
                        this.deptShiftDesc = this.assignmentDetail.shiftCode + " " + this.assignmentDetail.shiftDescription;
                        this.actualShiftStartTime = this.formatTime(this.assignmentDetail.actualStartTime);
                        this.actualShiftEndTime = this.formatTime(this.assignmentDetail.actualEndTime);
                        this.productiveType = this.assignmentDetail.productiveType;
                        this.isProductive = (this.assignmentDetail.productiveType == "Productive" || this.assignmentDetail.productiveTypeId == 1);
                        this.isSelfScheduled = this.assignmentDetail.selfScheduled;
                        this.canModify = ((this.isProductive == true || this.productiveType.toUpperCase() == 'CALL' || this.productiveType.toUpperCase() == 'PLACEHOLDER') && this.isSelfScheduled == true);
                    }
                })
                .catch((err: any) => {
                    if (err) {
                        console.log(err); // Handle errors any way you want
                    }
                });
        }

        getSelfScheduleNeedsDetails() {
            let selectedDateVal = (this.currentEvent.type == undefined ? moment(this.datesList[0].dateValue).format('YYYY-MM-DDTHH:mm:ss') : this.currentEvent.date);

            var scheduleIdVal = (this.scheduleId == undefined ?  this.currentEvent.assignmentId:this.scheduleId );
            const payload = { date: selectedDateVal, departmentIds: this.departmentsCanSelfSchedule, username: this.profileData.username, scheduleId :scheduleIdVal };

            this.$store
                .dispatch("schedule/GetSelfScheduleNeedsDetails", payload)
                .then((data) => {
                    this.isLoaded = true;
                    if (this.selfScheduleShiftDetails != undefined) {
                        this.facilities = this.selfScheduleFacilities;
                        let selectedFacility = this.facilities.find(f => f.facilityId == this.profileData.facilityId);

                        if (selectedFacility == 'undefined') {
                            selectedFacility = this.selectedFacilityId = this.facilities[0];
                        }

                        
                        this.selectedFacilityId = selectedFacility.facilityId;
                        this.facilityName = selectedFacility.facilityName;
                        this.facilityCoid = selectedFacility.coid;

                        this.facilityDepts = this.selfScheduleDepartments.filter(x => x.facilityId == selectedFacility.facilityId);
                        let selectedDept = this.facilityDepts.find(d => d.departmentId == this.profileData.deptId);

                        if (selectedDept == 'undefined' || selectedDept == null) {
                            this.isSelfScheduleNeedsInPrimaryDept = false;
                            selectedDept = this.facilityDepts[0]
                        }
                        this.selectedDeptId = selectedDept.departmentId;
                        this.departmentName = selectedDept.departmentCode;
                        this.departmentCode = selectedDept.departmentName;                       
                        this.skills = this.removeDuplicatesFromArrayByProperty(this.selfScheduleSkills.filter(x => x.departmentId == selectedDept.departmentId),'skillLevelId');           
                        let primarySkillId = this.profileData.skills.find(x => x.primary == true).id
                        let selectedSkill = this.skills.find(s => s.skillLevelId == primarySkillId);
                        
                        if (selectedSkill == 'undefined' || selectedSkill == null) {                            
                            selectedSkill = this.skills[0]
                        }

                        this.selectedSkillId = Number(selectedSkill.skillLevelId);
                        this.skillName = selectedSkill.skill;
                        

                        this.deptShifts = this.removeDuplicatesFromArrayByProperty(this.selfScheduleShiftDetails.filter(x => x.departmentId == this.selectedDeptId).filter(s => s.skillLevelId = this.selectedSkillId), 'shiftCode');

                        this.deptShifts.forEach((shift: any) => {
                            let startTime, endTime;
                            startTime = this.formatTime(this.addMinutes(shift.startTime, shift.offset));
                            endTime = this.formatTime(this.addMinutes(this.addMinutes(shift.endTime, shift.offset), shift.breakMinutes));

                            if (shift.shiftDescription.trim().toUpperCase() == shift.shiftCode.trim().toUpperCase()) {
                                shift.shiftDescription = shift.shiftDescription + " " + startTime.toUpperCase() + " - " + endTime.toUpperCase();
                            }
                        });
                        
                        this.selectedDeptAndShift = this.deptShifts[0];
                        this.selectedDeptShiftId = +this.deptShifts[0].departmentShiftId + '_' + this.deptShifts[0].departmentId;

                        this.setShiftDetails(this.deptShifts[0].departmentShiftId, this.deptShifts[0].departmentId);
                    }
                    else{
                            this.showErrorMsg = true;
                            this.errorMsg = "Self scheduling shifts not available. Please select a different date. ";                                    
                            return;                        
                    }
                })
                .catch((err: any) => {
                    if (err) {
                        console.log(err); // Handle errors any way you want
                    }
                });
        }

        validateBeforeSave() {
            let selectedDatesCount: number = 0;
            let isValidate: boolean = true;
            let errorMessage: string = "";
            for (var i = 0; i < this.datesList.length; i++) {
                if (this.datesList[i].isSelected) {
                    selectedDatesCount++;
                }
            }
            if (selectedDatesCount < 1) {
                isValidate = false;
                errorMessage = "Please select atleast one date";
            }
            else if (this.selectedFacilityId < 1) {
                isValidate = false;
                errorMessage = "Please select facility";
            }
            else if (this.selectedDeptId < 1) {
                isValidate = false;
                errorMessage = "Please select department";
            }
            else if (this.selectedSkillId < 1) {
                isValidate = false;
                errorMessage = "Please select skill";
            }          
           
            if(!isValidate)
            {
                this.showErrorMsg = true;
                this.errorType = "error";
                this.errorMsg = errorMessage;
                return false;
            }
            else{
                  return true;
            }
        }

        async SaveNeedsDetails() {
            var scheduleIdVal = (this.currentEvent.type == undefined ? this.scheduleId : this.currentEvent.assignmentId);
            var currSchedule = this.userSchedules.find(x => x.id == scheduleIdVal);
            if (this.currentEvent.type == undefined) {
                for (var i = 0; i < this.datesList.length; i++) {
                    if (this.showErrorMsg) {
                        break;
                    }

                    if (this.datesList[i].isSelected == true) //
                    {
                        var dateVal = moment(this.datesList[i].dateValue).format("YYYY-MM-DD");
                        var lstEvents: Event[] = currSchedule.events.filter(x => (x.type == "Pending" || x.type == "Assignment") && moment(x.date).format("YYYY-MM-DD")  == dateVal);
                        if (lstEvents != null) {
                            for (var j = 0; j < lstEvents.length; j++) {
                                const selectedDeptShift = this.deptShifts.find(x => x.shiftCode == lstEvents[j].shiftCode);
                                if ((selectedDeptShift.startTime < this.shiftEndTime) && (this.shiftStartTime < selectedDeptShift.endTime)) {
                                    this.isLoading = false;
                                    this.showErrorMsg = true;
                                    this.errorMsg = "Shifts may not overlap.\n Please select a shift with a different start or end time.";
                                    return;
                                }
                            }
                        }
                    }
                }

                if (!this.showErrorMsg) {

                    var item = 0;
                    for (var k = 0; k < this.datesList.length; k++) {
                        if (this.datesList[k].isSelected == true) //
                        {
                            var formattedStartTime = moment(`${this.datesList[k].dateValue} ${this.actualShiftStartTime}`, "YYYY-MM-DD h:mm a").toDate(); 
                            var formattedEndTime = moment(`${this.datesList[k].dateValue} ${this.actualShiftEndTime}`, "YYYY-MM-DD h:mm a").toDate(); 

                            if(moment(formattedEndTime).isBefore(moment(formattedStartTime)))
                            {  
                                formattedEndTime = moment(formattedEndTime).add(1, 'days').toDate();
                            }
                            var ShiftDetails = {
                                id: this.getGuidforPendingShift(),
                                username: this.profileData.username,
                                date: moment(this.datesList[k].dateValue).format("YYYY-MM-DD"),
                                startTime: this.shiftStartTime,
                                endTime: this.shiftEndTime,                                

                                actualStartTime: moment(formattedStartTime).format("YYYY-MM-DDTHH:mm:ss"),
                                actualEndTime: moment(formattedEndTime).format("YYYY-MM-DDTHH:mm:ss"),
                                departmentShiftId: this.selectedDeptAndShift.departmentShiftId,
                                scheduleId: scheduleIdVal,
                                tenantId: this.tenantId,
                                departmentId: this.selectedDeptId,
                                staffId: this.staffId,
                                skillId: this.selectedSkillId,
                                shiftCode: this.deptShiftCode,
                                shiftDescription: this.deptShiftDesc,
                                skill: this.skillName,
                                facilityName: this.facilityName,
                                departmentName: this.departmentName,
                                productiveType: this.productiveType,
                                shiftMembers: this.selfScheduleShiftMembers != undefined ? this.selfScheduleShiftMembers.shiftMembers : null,
                                actionableBy: currSchedule.endDate
                            };
                            this.pendingShiftList[item] = JSON.parse(JSON.stringify(ShiftDetails));
                            item++;
                        }
                    }

                    localStorage.setItem("lastUsedShiftCode", this.deptShiftCode);
                    this.isLoading = true;
                    await this.$store.dispatch('schedule/SavePendingShiftDetails', this.pendingShiftList)
                        .then((res: any) => {
                            //showing message in MyScheduleView Screen
                            this.isLoading = false;
                            this.$emit('showSuccessMsgPopUp');
                            this.$emit('closeSharedModal');
                        })
                        .catch((err: any) => {
                            if (err) {
                                this.isLoading = false;
                                console.log(err);
                                let parseResponse = err.request.responseText != "" ? JSON.parse(err.request.responseText) : err.request.responseText;
                                this.showErrorMsg = true;
                                if(parseResponse.Detail !=null ||parseResponse.Detail !=undefined  ){
                                    this.errorMsg =  JSON.parse(parseResponse.Detail);
                                }
                                else {
                                this.errorMsg = (parseResponse.result != null || parseResponse.result != undefined) ? JSON.parse(parseResponse.result).Message : "An error has occurred. Please try again. If the error persists, contact Facility Scheduler support.";
                                }
                            }
                        });
                }
            }
            else //Current Event
            {
                var lstEvents1: Event[] = currSchedule.events.filter(x => (x.type == "Pending" || x.type == "Assignment") && x.date == this.currentEvent.date);
                if (lstEvents1 != null) {
                    for (var l = 0; l < lstEvents1.length; l++) {
                        const selectedDeptShift = this.deptShifts.find(x => x.shiftCode == lstEvents1[l].shiftCode);
                        if ((selectedDeptShift.startTime < this.shiftEndTime) && (this.shiftStartTime < selectedDeptShift.endTime)) {
                            this.isLoading = false;
                            this.showErrorMsg = true;
                            this.errorMsg = "Shifts may not overlap.\n Please select a shift with a different start or end time.";
                            return;
                        }
                    }
                }

                if (!this.showErrorMsg) {
                 
                    
                    var formattedStart = moment(`${this.currentEvent.date} ${this.actualShiftStartTime}`, "YYYY-MM-DD h:mm a").toDate(); 
                    var formattedEnd = moment(`${this.currentEvent.date} ${this.actualShiftEndTime}`, "YYYY-MM-DD h:mm a").toDate(); 

                    if(moment(formattedEnd).isBefore(moment(formattedStart)))
                    {  
                        formattedEnd = moment(formattedEnd).add(1, 'days').toDate();
                    }

 
                    let ShiftDetails = {
                        id: this.getGuidforPendingShift(),
                        username: this.profileData.username,
                        date: this.currentEvent.date,
                        startTime: this.shiftStartTime,
                        endTime: this.shiftEndTime,                        
                        actualStartTime: moment(formattedStart).format("YYYY-MM-DDTHH:mm:ss"),
                        actualEndTime: moment(formattedEnd).format("YYYY-MM-DDTHH:mm:ss"),
                        departmentShiftId: this.selectedDeptAndShift.departmentShiftId,
                        scheduleId: scheduleIdVal,
                        tenantId: this.tenantId,
                        departmentId: this.selectedDeptId,
                        staffId: this.staffId,
                        skillId: this.selectedSkillId,
                        shiftCode: this.deptShiftCode,
                        shiftDescription: this.deptShiftDesc,
                        skill: this.skillName,
                        facilityId :this.selectedFacilityId,
                        facilityName: this.facilityName,
                        coid: this.facilityCoid,
                        departmentName: this.departmentName,
                        departmentCode:this.departmentCode,
                        productiveType: this.productiveType,
                        shiftMembers: this.selfScheduleShiftMembers != undefined ? this.selfScheduleShiftMembers.shiftMembers : null,
                        actionableBy: currSchedule.endDate
                    };
                    this.pendingShiftList[0] = JSON.parse(JSON.stringify(ShiftDetails));

                    localStorage.setItem("lastUsedShiftCode", this.deptShiftCode);
                    this.isLoading = true;
                    await this.$store.dispatch('schedule/SavePendingShiftDetails', this.pendingShiftList)
                        .then((res: any) => {
                            //showing message in MyScheduleView Screen
                            this.isLoading = false;
                            this.$emit('showSuccessMsgPopUp');
                            this.$emit('closeSharedModal');
                        })
                        .catch((err: any) => {
                            if (err) {
                                this.isLoading = false;
                                console.log(err);
                                let parseResponse = err.request.responseText != "" ? JSON.parse(err.request.responseText) : err.request.responseText;
                                this.showErrorMsg = true;
                                if(parseResponse.Detail !=null ||parseResponse.Detail !=undefined  ){
                                    this.errorMsg =  parseResponse.Detail;
                                }
                                else {
                                this.errorMsg = (parseResponse.result != null || parseResponse.result != undefined) ? JSON.parse(parseResponse.result).Message : "An error has occurred. Please try again. If the error persists, contact Facility Scheduler support.";
                                }
                            }
                        });
                }
            }
        }

        async SaveSelfScheduleAsAssignment() {
            var lstAssignments: any[] = [];
            if (this.currentEvent.type == undefined) {
                let item = 0;
                for (var i = 0; i < this.datesList.length; i++) {
                    if (this.datesList[i].isSelected == true) //
                    {
                        let ShiftDetails = {
                            //scheduleId: this.currentEvent.assignmentId,
                            tenantId: this.tenantId,
                            departmentShiftId: this.selectedDeptAndShift.departmentShiftId,
                            departmentId: this.selectedDeptId,
                            staffId: this.staffId,
                            skillLevelId: this.selectedSkillId,
                            date: moment(this.datesList[i].dateValue).format("YYYY-MM-DD"),
                            startTime: this.shiftStartTime,
                            productiveType: this.productiveType,
                            endTime: this.shiftEndTime,
                            scheduleId: this.scheduleId,
                            //shiftMembers: this.selfScheduleShiftMembers != undefined ? this.selfScheduleShiftMembers.shiftMembers : null
                        };
                        lstAssignments[item] = JSON.parse(JSON.stringify(ShiftDetails));
                        item++;
                    }
                }
            }
            else //Current Event
            {
                let ShiftDetails = {
                    scheduleId: this.currentEvent.assignmentId,
                    tenantId: this.tenantId,
                    departmentShiftId: this.selectedDeptAndShift.departmentShiftId,
                    departmentId:  this.selectedDeptId,
                    staffId: this.staffId,
                    skillLevelId: this.selectedSkillId,
                    date: this.currentEvent.date,
                    startTime: this.shiftStartTime,
                    productiveType: this.productiveType,
                    endTime: this.shiftEndTime,
                    //shiftMembers: this.selfScheduleShiftMembers != undefined ? this.selfScheduleShiftMembers.shiftMembers : null
                };
                lstAssignments[0] = JSON.parse(JSON.stringify(ShiftDetails));
            }

            this.isLoading = true;
            await this.$store.dispatch('schedule/SaveSelfScheduleAsAssignment', lstAssignments)
                .then((res: any) => {
                    //showing message in MyScheduleView Screen
                    this.isLoading = false;
                    this.$emit('showSuccessMsgPopUp');
                    this.$emit('closeSharedModal');
                })
                .catch((err: any) => {
                    if (err) {
                        this.isLoading = false;
                        console.log(err);
                        let parseResponse = err.response.data != "" ? err.response.data : "An error has occurred. Please try again. If the error persists, contact Facility Scheduler support.";
                        this.showErrorMsg = true;
                        this.errorMsg = parseResponse;
                    }
                });
        }

        async FireAction() {
            if (this.currentEvent.type == "Need" || (this.currentEvent.type == undefined && this.validateBeforeSave() == true)) // -- Add toSchedule
            {
                if (this.allowSelfScheduleToCommitment) {
                    this.SaveNeedsDetails();
                }
                else {
                    this.SaveSelfScheduleAsAssignment();
                }
            }
            else if (this.currentEvent.type != undefined ) // -- Withdraw
            {
                if (this.currentEvent.type == "Pending") {
                    this.isLoading = true;
                    await this.$store.dispatch('schedule/DeletePendingShiftDetails', { id: this.currentEvent.id, username: this.profileData.username })
                        .then((res: any) => {
                            // showing message in MyScheduleView Screen
                            this.isLoading = false;
                            this.$emit('showSuccessMsgPopUp');
                            this.$emit('closeSharedModal');
                        })
                        .catch((err: any) => {
                            if (err) {
                                this.isLoading = false;
                                console.log(err);
                                let parseResponse = err.request.responseText != "" ? JSON.parse(err.request.responseText) : err.request.responseText;
                                this.showErrorMsg = true;
                                this.errorMsg = (parseResponse.result != null || parseResponse.result != undefined) ? JSON.parse(parseResponse.result).Message : "An error has occurred. Please try again. If the error persists, contact Facility Scheduler support.";
                            }
                        });
                }
                else {
                    if (this.allowSelfScheduleToCommitment) {
                        if (this.isBelowCommitment()) {
                            this.confirmMsgValue = "The selected shift was removed from your requested schedule and you are now under your commitment. Please choose a replacement shift and click Submit to complete the scheduling process. Do you want to proceed?";
                            this.isConfirmModalVisible = true;
                        }
                        else {
                            this.confirmMsgValue = "This shift request will be removed. Do you want to proceed?";
                            this.isConfirmModalVisible = true;
                        }
                    }
                    else {
                        this.confirmMsgValue = "This shift request will be removed. Do you want to proceed?";
                        this.isConfirmModalVisible = true;
                    }
                }
            }    
        }
        getGuidforPendingShift() {
            var uuidValue = "", k, randomValue;
            for (k = 0; k < 32; k++) {
                randomValue = Math.random() * 16 | 0;
                if (k == 8 || k == 12 || k == 16 || k == 20) {
                    uuidValue += "-"
                }
                uuidValue += (k == 12 ? 4 : (k == 16 ? (randomValue & 3 | 8) : randomValue)).toString(16);
            }
            return uuidValue;
        }

        formatDate(date: Date): string {
            return moment(date).format("dddd, MMMM DD yyyy");
        }

        formatTime(t: Date): string {
            return moment(t).format("h:mm a");
        }

        addMinutes(date, minutes) {
            return moment(date).add(minutes, 'm').toDate();
        }

        async confirmedClicked() {
            this.isConfirmModalVisible = false;
            this.isLoading = true;
            await this.$store.dispatch('schedule/DeleteSelfScheduleAssignment', this.assignmentDetail.id)
                .then((res: any) => {
                    // showing message in MyScheduleView Screen
                    this.isLoading = false;
                    this.$emit('showSuccessMsgPopUp');
                    this.$emit('closeSharedModal');
                })
                .catch((err: any) => {
                    if (err) {
                        this.isLoading = false;
                        console.log(err);
                        let parseResponse =
                            err.request.response != ""
                                ? err.request.response
                                : "An error has occurred. Please try again. If the error persists, contact Facility Scheduler support.";
                        this.showErrorMsg = true;
                        this.errorMsg = parseResponse;
                    }
                });

        }

        isBelowCommitment() {
            let currdate = this.currentEvent.date;
            let currsched = this.userSchedules.length ? this.userSchedules[0] : null;
            currsched = null;
             this.userSchedules.forEach((sched: any) => {
                let startDt, endDt, currDt;
                startDt = sched.startDate;
                currDt = currdate;
                endDt = sched.endDate;
                if (
                    new Date(startDt) <= new Date(currDt) &&
                    new Date(endDt) >= new Date(currDt)
                ) {
                    currsched = sched;
                    return;
                }
            });

            let totalHrs = 0,
                totalMins = 0,
                weekStartDate: Date = new Date(currsched.startDate),
                weekEndDate: Date = new Date(currsched.startDate),
                weekEvents!: Event[],
                weekHours: number,
                isOverallCommitmentBelow: boolean = false,
                isWeekendCommitmentBelow: boolean = false;
 
            var formattedStartEndDate = moment(this.profileData.employeeEndDate, "YYYY-MM-DD").toDate(); 
            var formattedSchdEndDate = moment(currsched.endDate, "YYYY-MM-DD").toDate(); 

            if(moment(formattedStartEndDate).isBefore(moment(formattedSchdEndDate)))
            {  
                 return false;
            }

            for (var i = 0; i < this.weeksInSchedule; i++) {
                if (i == 0) {
                    weekEndDate.setDate(weekStartDate.getDate() + 6);
                }
                else {
                    weekStartDate.setDate(weekStartDate.getDate() + 7);
                    weekEndDate.setDate(weekStartDate.getDate() + 6);
                }

                if (weekStartDate <= new Date(currdate) && new Date(currdate) <= weekEndDate) {
                    weekEvents = currsched.events.filter(
                        (event: Event) =>
                            new Date(event.date) >= weekStartDate &&
                            new Date(event.date) <= weekEndDate && event.isCommitment == true &&
                            (event.type == "Pending" || event.type == "Assignment" || event.type == "Request")
                    );

                    weekEvents.forEach((event: Event) => {
                        totalHrs += event.hours;
                        totalMins += event.minutes;
                    });
                    if(this.currentEvent.isCommitment)
                    {
                        weekHours = Math.round((totalHrs + (totalMins / 60)) - (this.currentEvent.hours + (this.currentEvent.minutes / 60)));
                    }
                    else
                    {
                      weekHours = Math.round((totalHrs + (totalMins / 60)));
                    }
                    if (this.currentEvent.isWeekend) {
                        let weekendScheduledEvents: Event[] = currsched.events.filter(
                            (event: Event) =>
                                new Date(event.date) >= new Date(currsched.startDate) &&
                                new Date(event.date) <= new Date(currsched.endDate) &&
                                (event.type == "Pending" || event.type == "Assignment" || event.type == "Request") &&
                                event.isWeekend
                        );

                        if (this.displayWSC) {
                            if ((weekendScheduledEvents.length - 1) >= this.reqCountWSC) {
                                isWeekendCommitmentBelow = false;
                            }
                            else {
                                isWeekendCommitmentBelow = true;
                            }
                        }
                        else {
                            isWeekendCommitmentBelow = false;
                        }
                    }
                    if (weekHours < this.guranteedHrs || isWeekendCommitmentBelow) {
                        isOverallCommitmentBelow = true;
                    }
                    break;
                }
            }
            return isOverallCommitmentBelow;
        }

    }
